import processClient from '.'
import { getAuthHeaders } from 'utils/requests'
import { cacheClear } from 'utils/memoryCache'

const createProcess = async data => {
  const headers = { headers: getAuthHeaders() }
  const response = await processClient.post('/create', data, headers)
  cacheClear('processes:')
  return response
}

export default createProcess

